import { ThreadPrimitive } from "@assistant-ui/react";
import { ComposerFadeGradient } from "@circle-react-shared/AiConversation/composer/ComposerFadeGradient";
import { FloatingScrollToBottomButton } from "@circle-react-shared/AiConversation/thread/FloatingScrollToBottomButton";

import { t } from "@/i18n-js/instance";

import { AiPauseDivider } from "./AiPauseDivider";
import { AvatarAssistantMessage } from "./AvatarAssistantMessage";
import { AvatarUserMessage } from "./AvatarUserMessage";

const threadComponents = {
  UserMessage: AvatarUserMessage,
  AssistantMessage: AvatarAssistantMessage,
};

interface AvatarThreadProps {
  // The new pause state, set when it changed after the last message.
  trailingAiPauseChange?: boolean;
}

export const AvatarThread = ({ trailingAiPauseChange }: AvatarThreadProps) => (
  <ThreadPrimitive.Root className="flex min-h-0 flex-1 flex-col">
    <ThreadPrimitive.Viewport
      autoScroll
      scrollToBottomOnRunStart
      className="flex min-h-0 flex-1 flex-col overflow-y-auto px-4 pt-2"
    >
      <div className="mx-auto flex w-full max-w-2xl flex-1 flex-col">
        <div className="flex-1">
          <ThreadPrimitive.Messages components={threadComponents} />
          {trailingAiPauseChange !== undefined && (
            <AiPauseDivider isPaused={trailingAiPauseChange} />
          )}
        </div>
        <div className="bg-primary sticky bottom-0 z-10 h-2">
          <ComposerFadeGradient />
          <FloatingScrollToBottomButton
            label={t("circle_ai_home.scroll_to_bottom")}
          />
        </div>
      </div>
    </ThreadPrimitive.Viewport>
  </ThreadPrimitive.Root>
);
